import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmTimeAgoPipe } from './am-time-ago.pipe';

@NgModule({
  declarations: [AmTimeAgoPipe],
  imports: [CommonModule],
  exports: [AmTimeAgoPipe], // 🔥 make pipe available everywhere
})
export class AmTimeAgoModule {}
